<script setup lang="ts">
import Modal from '@/components/ui/Modal.vue'
import { useConfirm } from '@/composables/useConfirm'

// Mounted once at the app root; driven by useConfirm().confirm(...).
const { state, _resolve } = useConfirm()
</script>

<template>
  <Modal :is-open="state.open" :title="state.title || 'Please confirm'" size="sm" @close="_resolve(false)">
    <p class="text-sm text-gray-600 whitespace-pre-line">{{ state.message }}</p>
    <template #footer>
      <div class="flex justify-end gap-3">
        <button
          @click="_resolve(false)"
          class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50"
        >{{ state.cancelText }}</button>
        <button
          @click="_resolve(true)"
          :class="[
            'px-4 py-2 text-sm font-medium text-white rounded-lg',
            state.danger ? 'bg-red-600 hover:bg-red-700' : 'bg-admin-primary hover:bg-admin-primary/90',
          ]"
        >{{ state.confirmText }}</button>
      </div>
    </template>
  </Modal>
</template>
